<template>
  <div class="welcome">
    加入成功！
  </div>
</template>

<script>
export default {
name: "welcome"
}
</script>

<style scoped>
.welcome{
  font-size: .36rem;
  text-align: center;
}
</style>
